import { useEffect } from 'react';
import type { PagesRefs } from '@apps/guest/packages/layout-engine/layouts/LayoutAloha/LayoutAloha.types';
import { useDebounceScroll } from '@apps/guest/packages/layout-engine/layouts/LayoutAloha/hooks/useDebounceScroll';

type UsePageScrollAtTheBottomParams = Readonly<{
  container: HTMLDivElement | null;
  setIsPageScrollAtTheBottom?: (value: boolean) => void;
  pagesRef?: ReadonlyArray<PagesRefs>;
  setIsPastFirstPage?: (value: boolean) => void;
}>;

export const usePageScrollAtTheBottom = ({ container, setIsPageScrollAtTheBottom, pagesRef, setIsPastFirstPage }: UsePageScrollAtTheBottomParams) => {
  const onUserScroll = useDebounceScroll();

  useEffect(() => {
    const unsubscribe = onUserScroll(container, ({ scrollTop }) => {
      if (!container) return;

      const scrollBottomThreshold = 300;
      const containerScroll = scrollTop + container.offsetHeight;
      const isScrollAtTheEnd = container.scrollHeight - containerScroll < scrollBottomThreshold;
      setIsPageScrollAtTheBottom?.(isScrollAtTheEnd);

      // Past first page: first page's bottom is above the container's top (fully scrolled past)
      const firstPageRef = pagesRef?.[0]?.ref;
      if (setIsPastFirstPage && firstPageRef) {
        const firstPageBottom = firstPageRef.getBoundingClientRect().bottom;
        const containerTop = container.getBoundingClientRect().top;
        setIsPastFirstPage(firstPageBottom < containerTop);
      }
    });

    return () => unsubscribe?.();
  }, [container, setIsPageScrollAtTheBottom, setIsPastFirstPage, pagesRef, onUserScroll]);
};
